/**
 * @generated SignedSource<<c4211daec3e24a9b01b146820f7ded19>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CommunitySideBarPaginationQuery$variables = {
  after?: string | null;
  first: number;
  id: string;
};
export type CommunitySideBarPaginationQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"CommunitySideBar_PaginationFragment">;
  } | null;
};
export type CommunitySideBarPaginationQuery = {
  response: CommunitySideBarPaginationQuery$data;
  variables: CommunitySideBarPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v3 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  (v2/*: any*/),
  (v3/*: any*/),
  {
    "kind": "Literal",
    "name": "kind",
    "value": "custom"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerPermissions",
  "storageKey": null
},
v10 = {
  "alias": "nonNullProductId",
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberPermissions",
  "storageKey": null
},
v12 = {
  "alias": "nonNullProductId",
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v13 = [
  (v12/*: any*/),
  (v11/*: any*/)
],
v14 = {
  "alias": "nullableProductId",
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v15 = [
  (v14/*: any*/),
  (v11/*: any*/)
],
v16 = {
  "alias": "nullableProductIdString",
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v18 = [
  (v9/*: any*/)
],
v19 = {
  "kind": "InlineFragment",
  "selections": (v18/*: any*/),
  "type": "Organization",
  "abstractKey": null
},
v20 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    (v9/*: any*/),
    (v11/*: any*/)
  ],
  "type": "Product",
  "abstractKey": null
},
v21 = [
  (v12/*: any*/),
  (v9/*: any*/),
  (v11/*: any*/)
],
v22 = {
  "kind": "InlineFragment",
  "selections": (v21/*: any*/),
  "type": "Event",
  "abstractKey": null
},
v23 = [
  (v14/*: any*/),
  (v9/*: any*/),
  (v11/*: any*/)
],
v24 = {
  "kind": "InlineFragment",
  "selections": (v23/*: any*/),
  "type": "Comment",
  "abstractKey": null
},
v25 = {
  "kind": "InlineFragment",
  "selections": (v23/*: any*/),
  "type": "Feed",
  "abstractKey": null
},
v26 = {
  "kind": "InlineFragment",
  "selections": (v23/*: any*/),
  "type": "Post",
  "abstractKey": null
},
v27 = {
  "kind": "InlineFragment",
  "selections": [
    (v16/*: any*/),
    (v9/*: any*/),
    (v11/*: any*/)
  ],
  "type": "ContentUsage",
  "abstractKey": null
},
v28 = {
  "kind": "InlineFragment",
  "selections": (v23/*: any*/),
  "type": "ChatChannel",
  "abstractKey": null
},
v29 = {
  "kind": "InlineFragment",
  "selections": (v23/*: any*/),
  "type": "Dashboard",
  "abstractKey": null
},
v30 = {
  "kind": "InlineFragment",
  "selections": (v21/*: any*/),
  "type": "AssignmentSubmission",
  "abstractKey": null
},
v31 = {
  "kind": "InlineFragment",
  "selections": (v18/*: any*/),
  "type": "PathwayGroup",
  "abstractKey": null
},
v32 = {
  "kind": "InlineFragment",
  "selections": (v18/*: any*/),
  "type": "BrainSearch",
  "abstractKey": null
},
v33 = {
  "kind": "InlineFragment",
  "selections": [
    (v4/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/),
    (v22/*: any*/),
    (v24/*: any*/),
    (v25/*: any*/),
    (v26/*: any*/),
    (v27/*: any*/),
    (v28/*: any*/),
    (v29/*: any*/),
    (v30/*: any*/),
    (v31/*: any*/),
    (v32/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v35 = [
  (v5/*: any*/)
],
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalChannelId",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "Badge",
  "kind": "LinkedField",
  "name": "badge",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emoji",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mediaUrl",
      "storageKey": null
    },
    (v5/*: any*/)
  ],
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "organizationId",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfoObjectType",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v44 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CommunitySideBarPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "CommunitySideBar_PaginationFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommunitySideBarPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "communityNavSections",
                "args": (v6/*: any*/),
                "concreteType": "NavSectionNodeConnection",
                "kind": "LinkedField",
                "name": "navSections",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NavSectionNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NavSection",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductAppNodeConnection",
                            "kind": "LinkedField",
                            "name": "apps",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProductAppNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductApp",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      (v7/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "customAppUrl",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "customAppTitle",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Feed",
                                        "kind": "LinkedField",
                                        "name": "feed",
                                        "plural": false,
                                        "selections": [
                                          (v5/*: any*/),
                                          (v8/*: any*/),
                                          (v9/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v4/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v10/*: any*/),
                                                  (v11/*: any*/)
                                                ],
                                                "type": "Product",
                                                "abstractKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": (v13/*: any*/),
                                                "type": "Event",
                                                "abstractKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": (v15/*: any*/),
                                                "type": "Comment",
                                                "abstractKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": (v15/*: any*/),
                                                "type": "Feed",
                                                "abstractKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": (v15/*: any*/),
                                                "type": "Post",
                                                "abstractKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v16/*: any*/),
                                                  (v11/*: any*/)
                                                ],
                                                "type": "ContentUsage",
                                                "abstractKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": (v15/*: any*/),
                                                "type": "ChatChannel",
                                                "abstractKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": (v15/*: any*/),
                                                "type": "Dashboard",
                                                "abstractKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": (v13/*: any*/),
                                                "type": "AssignmentSubmission",
                                                "abstractKey": null
                                              }
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Product",
                                        "kind": "LinkedField",
                                        "name": "product",
                                        "plural": false,
                                        "selections": [
                                          (v17/*: any*/),
                                          (v8/*: any*/),
                                          (v33/*: any*/),
                                          (v5/*: any*/),
                                          (v34/*: any*/),
                                          {
                                            "alias": "connectedApps",
                                            "args": [
                                              {
                                                "kind": "Literal",
                                                "name": "includeNested",
                                                "value": true
                                              }
                                            ],
                                            "concreteType": "ProductAppNodeConnection",
                                            "kind": "LinkedField",
                                            "name": "productApps",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "ProductAppNodeEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ProductApp",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v5/*: any*/),
                                                      (v7/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": "productApps(includeNested:true)"
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ProductMembership",
                                            "kind": "LinkedField",
                                            "name": "viewerMembership",
                                            "plural": false,
                                            "selections": (v35/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Collection",
                                        "kind": "LinkedField",
                                        "name": "collection",
                                        "plural": false,
                                        "selections": (v35/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContentUsage",
                                        "kind": "LinkedField",
                                        "name": "contentUsage",
                                        "plural": false,
                                        "selections": (v35/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Product",
                                        "kind": "LinkedField",
                                        "name": "linkProduct",
                                        "plural": false,
                                        "selections": [
                                          (v17/*: any*/),
                                          (v5/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProductAppNodeConnection",
                                        "kind": "LinkedField",
                                        "name": "productApps",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ProductAppNodeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "ProductApp",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v5/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ChatChannel",
                                                    "kind": "LinkedField",
                                                    "name": "chatChannel",
                                                    "plural": false,
                                                    "selections": [
                                                      (v36/*: any*/),
                                                      (v5/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v37/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Dashboard",
                                        "kind": "LinkedField",
                                        "name": "forYouDashboard",
                                        "plural": false,
                                        "selections": (v35/*: any*/),
                                        "storageKey": null
                                      },
                                      (v38/*: any*/),
                                      (v39/*: any*/),
                                      (v40/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "productId",
                                        "storageKey": null
                                      },
                                      (v41/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "navSectionId",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ChatChannel",
                                        "kind": "LinkedField",
                                        "name": "chatChannel",
                                        "plural": false,
                                        "selections": [
                                          (v5/*: any*/),
                                          (v36/*: any*/),
                                          (v33/*: any*/),
                                          (v39/*: any*/),
                                          (v41/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v42/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v43/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "filters": null,
                            "handle": "connection",
                            "key": "AppsSidebarList_NavSectionFragment__apps",
                            "kind": "LinkedHandle",
                            "name": "apps"
                          },
                          {
                            "alias": null,
                            "args": (v44/*: any*/),
                            "concreteType": "ProductNodeConnection",
                            "kind": "LinkedField",
                            "name": "products",
                            "plural": false,
                            "selections": [
                              (v37/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProductNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Product",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      (v17/*: any*/),
                                      (v38/*: any*/),
                                      (v34/*: any*/),
                                      (v8/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProductMembership",
                                        "kind": "LinkedField",
                                        "name": "viewerMembership",
                                        "plural": false,
                                        "selections": [
                                          (v5/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "organizationMembershipId",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Organization",
                                        "kind": "LinkedField",
                                        "name": "organization",
                                        "plural": false,
                                        "selections": [
                                          (v5/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Dashboard",
                                            "kind": "LinkedField",
                                            "name": "forYouDashboard",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "ProductApp",
                                                "kind": "LinkedField",
                                                "name": "app",
                                                "plural": false,
                                                "selections": (v35/*: any*/),
                                                "storageKey": null
                                              },
                                              (v5/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v40/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "waitingRoomEndsAt",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "startDate",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "adminCanLearnMode",
                                        "storageKey": null
                                      },
                                      (v4/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v19/*: any*/),
                                          (v20/*: any*/),
                                          (v22/*: any*/),
                                          (v24/*: any*/),
                                          (v25/*: any*/),
                                          (v26/*: any*/),
                                          (v27/*: any*/),
                                          (v28/*: any*/),
                                          (v29/*: any*/),
                                          (v30/*: any*/),
                                          (v31/*: any*/),
                                          (v32/*: any*/)
                                        ],
                                        "type": "Node",
                                        "abstractKey": "__isNode"
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v42/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v43/*: any*/)
                            ],
                            "storageKey": "products(first:10)"
                          },
                          {
                            "alias": null,
                            "args": (v44/*: any*/),
                            "filters": null,
                            "handle": "connection",
                            "key": "ProductsSidebarList_NavSectionPaginationFragment__products",
                            "kind": "LinkedHandle",
                            "name": "products"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ordering",
                            "storageKey": null
                          },
                          (v41/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v42/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v43/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "communityNavSections",
                "args": (v6/*: any*/),
                "filters": [
                  "kind"
                ],
                "handle": "connection",
                "key": "CommunitySideBar__communityNavSections",
                "kind": "LinkedHandle",
                "name": "navSections"
              }
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "adcd2583c7eec64f487fab944058df23",
    "id": null,
    "metadata": {},
    "name": "CommunitySideBarPaginationQuery",
    "operationKind": "query",
    "text": "query CommunitySideBarPaginationQuery(\n  $after: String\n  $first: Int!\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...CommunitySideBar_PaginationFragment_2HEEH6\n    id\n  }\n}\n\nfragment AppSidebarItemFragment on ProductApp {\n  kind\n  status\n  visibility\n  customAppTitle\n  badge {\n    ...BadgeFragment\n    id\n  }\n  product {\n    ...usePermissionsFragment\n    id\n  }\n  forYouDashboard {\n    id\n  }\n  ...RemoveAppButtonFragment\n  ...ToggleAppStatusButtonFragment\n}\n\nfragment AppUtils_getLocationFragment on ProductApp {\n  id\n  kind\n  customAppUrl\n  product {\n    slug\n    id\n  }\n  feed {\n    id\n  }\n  chatChannel {\n    id\n  }\n  collection {\n    id\n  }\n  contentUsage {\n    id\n  }\n  linkProduct {\n    slug\n    id\n  }\n}\n\nfragment AppsSidebarDragDropProvider_OrganizationFragment on Organization {\n  id\n  forYouDashboard {\n    app {\n      id\n    }\n    id\n  }\n}\n\nfragment AppsSidebarList_NavSectionFragment on NavSection {\n  id\n  apps {\n    edges {\n      node {\n        id\n        kind\n        customAppUrl\n        customAppTitle\n        feed {\n          id\n          name\n          viewerPermissions\n          ...usePermissionsFragment\n        }\n        product {\n          slug\n          name\n          ...usePermissionsFragment\n          ...appLevelContextFragment\n          id\n        }\n        collection {\n          id\n        }\n        contentUsage {\n          id\n        }\n        linkProduct {\n          slug\n          id\n        }\n        productApps {\n          edges {\n            node {\n              id\n              chatChannel {\n                externalChannelId\n                id\n              }\n            }\n          }\n        }\n        forYouDashboard {\n          id\n        }\n        ...AppSidebarItemFragment\n        ...ContentAppSettingsButtonFragment\n        ...LinkAppSettingsButtonFragment\n        ...FeedAppSettingsButtonFragment\n        ...GenericAppSettingsButtonFragment\n        ...CollectionAppSettingsButtonFragment\n        ...ChatChannelSettingsModalButtonFragment\n        ...ChatChannelSideBarItemFragment\n        ...NavFolderSettingsDropdownFragment\n        ...EventsAppSettingsButtonFragment\n        ...MembersAppSettingsButtonFragment\n        ...DashboardAppSettingsButtonFragment\n        ...AppUtils_getLocationFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment BadgeFragment on Badge {\n  kind\n  color\n  icon\n  emoji\n  mediaUrl\n}\n\nfragment ChatChannelBadgeFragment on ProductApp {\n  badge {\n    ...BadgeFragment\n    id\n  }\n  chatChannel {\n    visibility\n    id\n  }\n}\n\nfragment ChatChannelSettingsModalButtonFragment on ProductApp {\n  id\n  productId\n}\n\nfragment ChatChannelSideBarItemFragment on ProductApp {\n  id\n  customAppTitle\n  chatChannel {\n    id\n    externalChannelId\n    ...usePermissionsFragment\n  }\n  product {\n    slug\n    name\n    viewerMembership {\n      id\n    }\n    id\n  }\n  ...ChatChannelBadgeFragment\n  ...ChatChannelSettingsModalButtonFragment\n  ...DeleteChatChannelAppButtonFragment\n  ...AppUtils_getLocationFragment\n}\n\nfragment CollectionAppSettingsButtonFragment on ProductApp {\n  id\n  ...CollectionAppSettingsModalFragment\n}\n\nfragment CollectionAppSettingsModalFragment on ProductApp {\n  id\n}\n\nfragment CommunitySideBar_PaginationFragment_2HEEH6 on Organization {\n  communityNavSections: navSections(kind: custom, first: $first, after: $after) {\n    edges {\n      node {\n        id\n        ...NavSectionFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment ContentAppSettingsButtonFragment on ProductApp {\n  id\n  ...ContentAppSetupModalFragment\n}\n\nfragment ContentAppSetupModalFragment on ProductApp {\n  id\n}\n\nfragment DashboardAppSettingsButtonFragment on ProductApp {\n  id\n  ...DashboardAppSetupModalFragment\n}\n\nfragment DashboardAppSetupModalContentFragment on ProductApp {\n  id\n  forYouDashboard {\n    id\n  }\n}\n\nfragment DashboardAppSetupModalFragment on ProductApp {\n  customAppTitle\n  forYouDashboard {\n    id\n  }\n  ...DashboardAppSetupModalContentFragment\n}\n\nfragment DeleteChatChannelAppButtonFragment on ProductApp {\n  id\n  navSectionId\n  product {\n    id\n    slug\n  }\n  chatChannel {\n    id\n    organizationId\n  }\n}\n\nfragment DeleteNavFolderButtonFragment on ProductApp {\n  id\n  customAppTitle\n  productApps {\n    totalCount\n  }\n}\n\nfragment DeleteNavSectionButtonFragment on NavSection {\n  id\n  title\n  kind\n  ordering\n  organizationId\n}\n\nfragment DeletePathwayButton_productFragment on Product {\n  id\n  name\n  type\n  ...usePermissionsFragment\n}\n\nfragment EventsAppSettingsButtonFragment on ProductApp {\n  id\n  ...EventsAppSetupModalFragment\n}\n\nfragment EventsAppSetupModalFragment on ProductApp {\n  id\n}\n\nfragment ExperienceAdminDropdownFragment on Product {\n  id\n  slug\n  type\n  name\n  adminCanLearnMode\n  ...LearnModeSwitchFragment\n  ...usePermissionsFragment\n}\n\nfragment FeedAppSettingsButtonFragment on ProductApp {\n  id\n  ...FeedAppSetupModalFragment\n}\n\nfragment FeedAppSetupModalFragment on ProductApp {\n  id\n}\n\nfragment GenericAppSettingsButtonFragment on ProductApp {\n  id\n  ...GenericAppSettingsModalFragment\n}\n\nfragment GenericAppSettingsModalFragment on ProductApp {\n  id\n  kind\n}\n\nfragment LearnModeSwitchFragment on Product {\n  id\n  name\n  status\n  viewerMembership {\n    id\n  }\n}\n\nfragment LeaveProductButtonFragment on Product {\n  name\n  slug\n  type\n  viewerMembership {\n    id\n    organizationMembershipId\n  }\n}\n\nfragment LinkAppSettingsButtonFragment on ProductApp {\n  id\n  ...LinkAppSetupModalFragment\n}\n\nfragment LinkAppSetupModalFragment on ProductApp {\n  id\n  kind\n}\n\nfragment MemberDirectoryAppSettingsModalFragment on ProductApp {\n  id\n  kind\n}\n\nfragment MembersAppSettingsButtonFragment on ProductApp {\n  id\n  kind\n  productId\n  ...MemberDirectoryAppSettingsModalFragment\n}\n\nfragment MyExperiencesListItemFragment on Product {\n  id\n  name\n  slug\n  status\n  viewerMembership {\n    id\n  }\n  organization {\n    ...AppsSidebarDragDropProvider_OrganizationFragment\n    id\n  }\n  ...ProductBadgeFragment\n  ...usePermissionsFragment\n  ...useIsWaitingRoomEnabledActiveProductFragment\n  ...ExperienceAdminDropdownFragment\n  ...LeaveProductButtonFragment\n  ...LearnModeSwitchFragment\n}\n\nfragment NavFolderSettingsButtonFragment on ProductApp {\n  id\n}\n\nfragment NavFolderSettingsDropdownFragment on ProductApp {\n  id\n  product {\n    ...usePermissionsFragment\n    id\n  }\n  ...NavFolderSettingsButtonFragment\n  ...DeleteNavFolderButtonFragment\n}\n\nfragment NavSectionFragment on NavSection {\n  id\n  kind\n  title\n  apps {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  products(first: 10) {\n    totalCount\n  }\n  ...UpdateNavSectionButtonFragment\n  ...DeleteNavSectionButtonFragment\n  ...ProductsSidebarList_NavSectionPaginationFragment\n  ...AppsSidebarList_NavSectionFragment\n}\n\nfragment PathwaySidebarItemFragment on Product {\n  id\n  name\n  slug\n  status\n  type\n  viewerMembership {\n    id\n  }\n  organization {\n    ...AppsSidebarDragDropProvider_OrganizationFragment\n    id\n  }\n  ...usePermissionsFragment\n  ...LeaveProductButtonFragment\n  ...ProductBadgeFragment\n  ...usePathwayAdminDropdownItemsFragment\n}\n\nfragment ProductBadgeFragment on Product {\n  id\n  badge {\n    ...BadgeFragment\n    id\n  }\n}\n\nfragment ProductsSidebarList_NavSectionPaginationFragment on NavSection {\n  id\n  products(first: 10) {\n    edges {\n      node {\n        id\n        slug\n        status\n        type\n        ...MyExperiencesListItemFragment\n        ...PathwaySidebarItemFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment RemoveAppButtonFragment on ProductApp {\n  id\n  kind\n  customAppTitle\n  feed {\n    id\n    name\n  }\n  collection {\n    id\n  }\n  productId\n  organizationId\n  navSectionId\n}\n\nfragment ToggleAppStatusButtonFragment on ProductApp {\n  id\n  status\n  kind\n  product {\n    type\n    id\n  }\n}\n\nfragment UpdateNavSectionButtonFragment on NavSection {\n  id\n  title\n}\n\nfragment appLevelContextFragment on Product {\n  id\n  name\n  slug\n  type\n  ...useConnectedProductAppsActiveProductFragment\n}\n\nfragment useConnectedProductAppsActiveProductFragment on Product {\n  connectedApps: productApps(includeNested: true) {\n    edges {\n      node {\n        id\n        kind\n      }\n    }\n  }\n}\n\nfragment useIsWaitingRoomEnabledActiveProductFragment on Product {\n  waitingRoomEndsAt\n  startDate\n  ...usePermissionsFragment\n}\n\nfragment usePathwayAdminDropdownItemsFragment on Product {\n  id\n  slug\n  ...usePermissionsFragment\n  ...DeletePathwayButton_productFragment\n}\n\nfragment usePermissionsFragment on Node {\n  __isNode: __typename\n  __typename\n  ... on Organization {\n    viewerPermissions\n  }\n  ... on Product {\n    nonNullProductId: id\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Event {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Comment {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Feed {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Post {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ContentUsage {\n    nullableProductIdString: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ChatChannel {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Dashboard {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on AssignmentSubmission {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on PathwayGroup {\n    viewerPermissions\n  }\n  ... on BrainSearch {\n    viewerPermissions\n  }\n}\n"
  }
};
})();

(node as any).hash = "3f51a7b3aa198970850acefe785d20b2";

export default node;
